function randomImagePicker(imageArray) {
    let len = imageArray.length;
    let randomIndex = Math.floor(Math.random() * len)
    let randomImage = imageArray[randomIndex];
  return (
    randomImage
  )
}

export default randomImagePicker